<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="ApplyData"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        资料申请
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 实习证明或在职证明 -->
    <div class="labourParticulars" v-if="fingerprintShow1">
        <h4 class="labourParticulars-title labourParticulars-title-active" id="active-box-border">实习证明或在职证明</h4>
        <span class="spanClass">先由申请人发送申请邮件（如有固定模板要求可添加附件）给直属主管，同时抄送王学军（wangxuejun）；再由直属主管向部门总监及人力资源总监报批；部门总监及人力资源总监审批通过后，申请人联系王学军（wangxuejun）并前往人力资源部开具实习证明或在职证明。</span>
    </div>
    <!-- 收入证明 -->
    <div class="labourParticulars" v-if="fingerprintShow2">
        <h4 class="labourParticulars-title labourParticulars-title-active" id="active-box-border">收入证明</h4>
        <span class="spanClass">先由申请人发送申请邮件（如有固定模板要求可添加附件）给直属主管，同时抄送张博雅（zhangboya3）；再由直属主管向部门总监及人力资源总监报批；部门总监及人力资源总监审批通过后，申请人联系张博雅（zhangboya3）并前往人力资源部开具收入证明。</span>
    </div>
    <!-- 人力资源印章 -->
    <div class="labourParticulars" v-if="fingerprintShow3">
        <h4 class="labourParticulars-title labourParticulars-title-active" id="active-box-border">人力资源印章</h4>
        <span class="spanClass">在办理相关业务的合理需要下，先由申请人发送申请邮件（说明具体用途，并附上需盖章文件）给直属主管，同时抄送王学军（wangxuejun）、薛宇婷（xueyuting3），再由直属主管向部门总监及人力资源总监报批；部门总监及人力资源总监审批通过后，申请人联系王学军（wangxuejun）、薛宇婷（xueyuting3）并前往人力资源部办理盖章。</span>
    </div>

    <div class="labourParticulars" v-if="fingerprintShow4">
        <h4 class="labourParticulars-title labourParticulars-title-active" id="active-box-border">劳动合同原件及复印件</h4>
        <span class="spanClass">在办理落户或其他相关业务的合理需求下，先由申请人发送申请邮件（说明具体用途）给直属主管，同时抄送王学军（wangxuejun）、薛宇婷（xueyuting3），再由直属主管向部门总监及人力资源总监报批；部门总监及人力资源总监审批通过后，申请人联系王学军（wangxuejun）、薛宇婷（xueyuting3），等待人力资源部的通知，前往领取。</span>
    </div>
</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow1: false,
            fingerprintShow2: false,
            fingerprintShow3: false,
            fingerprintShow4: false,
        };
    },
    methods: {
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "777"
                }
            })
        },
        fn() {
            var code = this.$route.params.code;
            if (code == 1) {
                this.fingerprintShow1 = true;
            } else if (code == 2) {
                this.fingerprintShow2 = true;
            }else if (code == 3) {
                this.fingerprintShow3 = true;
            }else if (code == 4) {
                this.fingerprintShow4 = true;
            }
        }
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 10px;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    display: block;
    margin: 10px auto;
}

.labourParticulars-title-active {
    font-size: 16px;
}
#active-box-border {
    margin-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/ApplyData/applyData1.vue